import { Field, TextInput, TextArea, SectionCard } from "./_shared";

export default function EditWhatsapp({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Botão WhatsApp">
      <div className="space-y-5">
        <Field label="Número (formato internacional, ex: +5511999999999)" hint="Apenas dígitos serão enviados ao WhatsApp.">
          <TextInput value={value.number} onChange={(v) => set("number", v)} testId="wa-number-input" />
        </Field>
        <Field label="Texto de exibição (visual)">
          <TextInput value={value.display} onChange={(v) => set("display", v)} testId="wa-display-input" />
        </Field>
        <Field label="Mensagem pré-preenchida">
          <TextArea value={value.message} onChange={(v) => set("message", v)} rows={3} testId="wa-message-input" />
        </Field>
        <Field label="Texto do botão flutuante">
          <TextInput value={value.floatText} onChange={(v) => set("floatText", v)} testId="wa-float-text-input" />
        </Field>
      </div>
    </SectionCard>
  );
}
